module.exports = __webpack_public_path__ + "img/printer.12edbc0c.svg";